import { 
    apiRequest,
    positionPeriodList
} from "../../../../../services/adapters/master/positionService"

class IndexRepository {
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", positionPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default IndexRepository
